import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined;

export const isSupabaseConfigured = Boolean(url && key && !url.includes("YOUR_PROJECT") && !key.includes("REPLACE_ME"));
export const supabase: SupabaseClient | null = isSupabaseConfigured ? createClient(url!, key!) : null;
